import { cdnFontsPath, cdnUrl } from '../consts'

const baseUrl = cdnUrl + cdnFontsPath

export default `
@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Thin.woff2") format("woff2");
  font-weight: 100;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-ThinItalic.woff2") format("woff2");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-ExtraLight.woff2") format("woff2");
  font-weight: 200;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-ExtraLightItalic.woff2") format("woff2");
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Light.woff2") format("woff2");
  font-weight: 300;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-LightItalic.woff2") format("woff2");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Regular.woff2") format("woff2");
  font-weight: 400;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Italic.woff2") format("woff2");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Medium.woff2") format("woff2");
  font-weight: 500;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-MediumItalic.woff2") format("woff2");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-SemiBold.woff2") format("woff2");
  font-weight: 600;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-SemiBoldItalic.woff2") format("woff2");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Bold.woff2") format("woff2");
  font-weight: 700;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-BoldItalic.woff2") format("woff2");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-ExtraBold.woff2") format("woff2");
  font-weight: 800;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-ExtraBoldItalic.woff2") format("woff2");
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-Black.woff2") format("woff2");
  font-weight: 900;
}

@font-face {
  font-family: "Gantari";
  font-display: swap;
  src: url("${baseUrl}/gantari/Gantari-BlackItalic.woff2") format("woff2");
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: "DNV Display";
  src: url("${baseUrl}/dnvdisplay/dnv-display-light.woff2");
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: "DNV Display";
  src: url("${baseUrl}/dnvdisplay/dnv-display-regular.woff2");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "DNV Display";
  src: url("${baseUrl}/dnvdisplay/dnv-display-medium.woff2");
  font-weight: 500;
  font-style: normal;
}
`
